import { FormulationAction, EFormulationActions } from '../actions/formulation.action';
import { IFormulationState, initialFormulationState } from '../state/formulation.state';


export function formulationReducers(state = initialFormulationState, action: FormulationAction): IFormulationState {
    switch (action.type) {



        case EFormulationActions.GetAllFormulationStockSuccess: {
            // console.log(action.payload)
            return {
                ...state,
                getAllFormulationStockSuccess: action.payload,
                getAllFormulationStockError: null
            };
        }

        case EFormulationActions.GetAllFormulationsSuccess: {
            // console.log(action.payload)
            return {
                ...state,
                getAllFormulationsSuccess: action.payload,
                getAllFormulationsError: null
            };
        }
        case EFormulationActions.GetAllFormulationsByCompanyIdSuccess: {
            // console.log(action.payload)
            return {
                ...state,
                getAllFormulationsByCompanyIdSuccess: action.payload,
                getAllFormulationsByCompanyIdError: null
            };
        }
        case EFormulationActions.GetFormulationNumberSuccess:{
            return {
                ...state,
                 getFormulationNumberSuccess:  action.payload,
                 getFormulationNumberError:null
             }
        }
        case EFormulationActions.GetInActiveStatusSuccess: {
            return {
                ...state,
                getInActiveStatusSuccess:action.payload,
                getInActiveStatusError:null

            }
        }
        case EFormulationActions.GetInActiveStatusError: {
            return {
                ...state,
                getInActiveStatusError:action.payload,
                getInActiveStatusSuccess:null

            }
        }
        case EFormulationActions.GetActiveStatusSuccess: {
            return {
                ...state,
                getActiveStatusSuccess:action.payload,
                getActiveStatusError:null

            }
        }
        case EFormulationActions.GetActiveStatusError: {
            return {
                ...state,
                getActiveStatusError:action.payload,
                getActiveStatusSuccess:null

            }
        }
        case EFormulationActions.GetAllFormulationsError: {

            return {
                ...state,
                getAllFormulationsError: action.payload,
                getAllFormulationsSuccess: null
            };
        }
        case EFormulationActions.GetAllFormulationsByCompanyIdError: {

            return {
                ...state,
                getAllFormulationsByCompanyIdError: action.payload,
                getAllFormulationsByCompanyIdSuccess: null
            };
        }
        case EFormulationActions.GetAllFormulationStockError: {

            return {
                ...state,
                getAllFormulationStockError: action.payload,
                getAllFormulationStockSuccess: null
            };
        }
        case EFormulationActions.GetAddFormulationSuccess: {
            return {
                ...state,
                getAddFormulationSuccess: action.payload,
                getAddFormulationError: null
            };
        }
        case EFormulationActions.GetAddFormulationError: {
            return {
                ...state,
                getAddFormulationError: action.payload,
                getAddFormulationSuccess: null
            };
        }
        case EFormulationActions.GetEditFormulationSuccess: {
            return {
                ...state,
                getEditFormulationSuccess: action.payload,
                getEditFormulationError: null
            };
        }
        case EFormulationActions.GetEditFormulationError: {
            return {
                ...state,
                getEditFormulationError: action.payload,
                getEditFormulationSuccess: null
            };
        }
        case EFormulationActions.SetFormulaByIdSuccess: {
            return {
                ...state,
                getFormulaByIdSucces: action.payload,
                getFormulaByIdError: null
            };
        }
        case EFormulationActions.SetFormulaByIdError: {
            return {
                ...state,
                getFormulaByIdError: action.payload,
                getFormulaByIdSucces: null
            };
        }
        case EFormulationActions.GetActiveFormulationsSuccess: {
            return {
                ...state,
                getActiveFormulationSuccess: action.payload,
                getActiveFormulationError: null
            };
        }
        case EFormulationActions.GetActiveFormulationsError: {
            return {
                ...state,
                getActiveFormulationError: action.payload,
                getActiveFormulationSuccess: null
            };
        }
        case EFormulationActions.GetMlcsByFormulaIdSuccess: {
            return {
                ...state,
                getMlcsbyFormulaIdSuccess: action.payload,
                getMlcsbyFormulaIdError: null
            };
        }
        case EFormulationActions.GetMlcsByFormulaIdError: {
            return {
                ...state,
                getMlcsbyFormulaIdError: action.payload,
                getMlcsbyFormulaIdSuccess: null
            };
        }
        case EFormulationActions.GetImportProductSuccess: {
            return {
                ...state,
                getImportProductSuccess: action.payload,
                getImportProductError: null
            };
        }
        case EFormulationActions.GetImportProductError: {
            return {
                ...state,
                getImportProductError: action.payload,
                getImportProductSuccess: null
            };
        }
        case EFormulationActions.GetParentFormulasSuccess: {
            return {
                ...state,
                getParentFormulasSuccess: action.payload,
                getParentFormulasError: null
            };
        }
        case EFormulationActions.GetParentFormulasError: {
            return {
                ...state,
                getParentFormulasError: action.payload,
                getParentFormulasSuccess: null
            };
        }

        // P391 S193: the request clears both slots; only the server's answer fills one.
        case EFormulationActions.SubEditFormula: {
            return {
                ...state,
                getSubEditFormulaSuccess: null,
                getSubEditFormulaError: null
            };
        }
        case EFormulationActions.SubEditFormulaSuccess: {
            return {
                ...state,
                getSubEditFormulaSuccess: action.payload,
                getSubEditFormulaError: null
            };
        }
        case EFormulationActions.SubEditFormulaError: {
            return {
                ...state,
                getSubEditFormulaError: action.payload,
                getSubEditFormulaSuccess: null
            };
        }
        default: {
            return state;
          }
    }

}
